import { requiredEmailSchema, requiredStringSchema } from "utils/yup"
import * as yup from "yup"

export const defaultValues = {
  email: "",
  first_name: "",
  last_name: "",
}

export const validateSchema = yup.object({
  email: requiredEmailSchema,
  first_name: requiredStringSchema.min(2),
  last_name: requiredStringSchema.min(2),
})
